'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Download = function (_React$PureComponent) {
  _inherits(Download, _React$PureComponent);

  function Download() {
    _classCallCheck(this, Download);

    return _possibleConstructorReturn(this, (Download.__proto__ || Object.getPrototypeOf(Download)).apply(this, arguments));
  }

  _createClass(Download, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          color = _props.color;

      return _react2.default.createElement(
        'svg',
        { width: size, height: size, viewBox: '0 0 20 20' },
        _react2.default.createElement(
          'g',
          { fill: 'none', fillRule: 'evenodd' },
          _react2.default.createElement('circle', { cx: '10', cy: '10', r: '10', fill: color }),
          _react2.default.createElement('path', {
            fill: '#FFF',
            d: 'M14.071 10.868h-2.806v-6.42a.448.448 0 0 0-.126-.316.391.391 0 0 0-.297-.132H9.16a.391.391 0 0 0-.297.132.448.448 0 0 0-.126.316v6.42H5.931a.394.394 0 0 0-.39.274.423.423 0 0 0 .093.493l4.075 4.232a.394.394 0 0 0 .591 0l4.068-4.235a.423.423 0 0 0 .09-.492.394.394 0 0 0-.387-.272z'
          })
        )
      );
    }
  }]);

  return Download;
}(_react2.default.PureComponent);

Download.defaultProps = {
  size: 20,
  color: '#1ABC9C'
};

Download.propTypes = {
  size: _propTypes2.default.number,
  color: _propTypes2.default.string
};

exports.default = Download;